import { Component, AfterViewInit } from '@angular/core';
import { Router } from "@angular/router";
import { ForgotPasswordRequest } from "./forgot-password-request";
import { AdminService } from "../../service/admin.service";
import { UtilService } from "../../service/util.service";
import * as constants from '../../app.constants';

declare let $: any;

@Component({
    selector: 'forgot-password',
    template: require('./forgot-password.component.html'),
    styles: [require('./forgot-password.component.css')]
})
export class ForgotPasswordComponent implements AfterViewInit {

    model: ForgotPasswordRequest;
    errorMsg: string;
    successMsg: string;

    constructor(
        private router: Router,
        private adminService: AdminService)
    {
        this.model = new ForgotPasswordRequest();
        //this.successMsg = "An email has been sent to your email id.";
    }

    ngAfterViewInit(): void {
        $("#email").focus();
    }

    forgotPassword(): void {
        console.log(' ForgotPassword form submitted.');
        console.log(this.model);
        this.errorMsg = null;
        if (!this.model.email || !UtilService.validateEmail(this.model.email)) {
           // this.errorMsg = constants.messages.invalidEmail;
        } else {
            this.adminService
                .postCall(constants.URLs.forgotPassword, this.model, false)
                .then(res => {
                    console.log('res');
                    console.log(res);
                    if (res.status == 1 && res.response && res.response.message) {
                        this.successMsg = res.response.message;
                    } else if (res.error && res.error.errors && res.error.errors.length) {
                        this.errorMsg = res.error.errors[0].message
                    } else {
                        this.errorMsg = res.error.message;
                    }
                })
                .catch((error: any) => {
                    console.error('ForgotPasswordComponent- an error occurred', error);
                    this.errorMsg = error.message? error.message: constants.messages.serverError;
                });
        }
    }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/forgot-password/forgot-password.component.ts